<template>
    <div>
        <LiveMatchesUpcaming :filter="query" onLive="1" activeSport="1"></LiveMatchesUpcaming>
    </div>
</template>

<script>
    import CompetitionSide from '@/components/sportsbook/CompetitionSide';
    import matches from '@/components/sportsbook/matches';
    import BetSlip from '@/components/sportsbook/BetSlip';
    import odd from '@/components/sportsbook/odd';
    import sportToolbar from '@/components/sportsbook/sportToolbar'
    import playingWidget from '@/components/sportsbook/widget/playing'
    import transfer from '@/components/transfer/form/transfer'
    import LiveMatchesUpcaming from "./liveMatchesUpcaming";
    export default {
        name: "liveUpcaming",
        components: {LiveMatchesUpcaming, CompetitionSide, matches, BetSlip, odd, sportToolbar, playingWidget, transfer},
        data() {
            return {
                t: this.$root.t,
                live: 1,
                selectedMatch: {},
                viewport: 1,
                query: {
                    onLive: 1
                },
                events: null
            }
        },
        watch: {
            '$route.query.view'(o, n) {
                this.viewport = o;
            },
            '$route'(o, n) {
                window.scrollTo(0, 0);
                if (!this.$route.params.sport) {
                    setTimeout(this.init, 500);
                }
            },
        },
        destroyed() {
            //wss.unsubscribe("stream/odd");
        },
        mounted() {
            this.init
            setTimeout(this.init, 500);

            var th = this;
            this.$bus.$on('FixtureEvents', ($event) => {

                if (!th.events)
                    th.events = $event;

            })
        },
        methods: {
            changeViewPort(v) {
                this.viewport = v;
            },
            init() {

                if (this.$route.query.view) {
                    this.viewport = this.$route.query.view;
                }

                var th = this;

                this.$bus.$on('selectedMatch', (payload) => {
                    th.selectedMatch = payload;
                });
            }
        }
    }
</script>

<style scoped>
    .cebg {
        top: -10px;
        position: absolute;
        width: 90%;
        height: 90%;
        opacity: 0.3;
        z-index: 4;
    }
    .score {
        color: yellow
    }
    .el-tablo {
        position: relative;
        z-index: 2
    }

    .element-wrapper .element-header {
        border-bottom: 3px solid #7b7b7b;
        line-height: 29px;
        min-height: 29px;
        padding: 7px 0 0 10px;
        background: #fff;
        font-weight: 400;
        color: #7b7b7b;
        font-size: 16px;
        box-sizing: border-box;
        font-family: 'Roboto', Helvetica, Arial, sans-serif;
    }

    .element-wrapper .element-header:after {
        background: none;
        content: '';
        width: 0;
        height: 0;
        display: none;
        bottom: 0;
        left: 0;
    }

    @media (max-width: 1700px) {
        .odd-dropdown {
            display: none;
        }
        .odd-block .odd-area {
            width: 100%;
        }
        .odd-block {
            width: 290px !important;
        }
    }

    @media (max-width: 1269px) {
        .odd-dropdown {
            display: none;
        }
        .odd-block .odd-area {
            width: 100%;
        }
        .odd-block {
            width: 220px !important;
        }

    }

    @media (max-width: 1500px) {
        .odd-dropdown, .outcome {
            display: none;
        }
    }

    .table {
        margin: 0;
    }
    .table tbody {
    }
    .table th, .table td {
        border-top: none;
        text-shadow: 0 1px #000;
        padding: 5px 2px 0 2px !important;
        vertical-align: top !important;
    }
    .competition_head{
        position: relative;
    }
    .odd-container {
        width: 870px;
        height: 100%;
        overflow: auto;
        padding-left: 20px;
    }
    .betslip-block {
        min-width: 260px;
        min-width: 310px;
        padding: 0 30px;
        height: 100%;
        overflow: auto;
    }
    .match-block {
        font-size: 14px;
        box-shadow: inset -4px -11px 2px -9px rgba(0,0,0,0.15);
    }
    .match-block:hover {
    }
    .match-block td {
        padding-top: 5px !important
    }
    .odd-block {
        width: 740px;
    }
    .odd-dropdown .odd-area{
        width: 100% !important;
    }
    .odd-area {
        width: 50%;
        height: 40px;
        overflow: hidden;
        font-size: 12px;
    }
    .odd-area.with-special {
        overflow: hidden;
        position: relative;
        width: 100%;
        z-index: 1;
        padding: 0 0 0 2px;
        border-radius: 5px;
    }
    .odd-area.with-special.drop {
        height: auto;
        z-index: 5;
    }
    .odd-area .x1 {
        width: 20%;
        float: left;
    }
    .odd-area .x2 {
        width: 50%;
        float: left;
    }
    .odd-area .x2x {
        width: 36%;
        float: left;
    }
    .odd-area .x3 {
        width: 33.2%;
        float: left;
    }
    .odd-area .x4 {
        width: 20%;
        float: left;
    }
    .odd-dropdown {
        width: 50%;

    }
    .team-block {
        width: 100px;
        padding: 0;
    }
    .team-repeat {
        width: 140px;
        float: left;
    }
    .team-repeat img{
        margin-right: 5px;
    }
    .table.table-padded tbody td {

    }
    .icon-w {
        font-size: 20px;
    }
    .hre {
        width: 100%;
        height: 1px;
        margin: 5px 0 5px 0;
    }

    .table th img, .table td img {
        max-width: none;
    }

    .table.table-padded tbody td {
        padding: 0.2rem 1.1rem;
    }

    #toggles {
        width: 50px;
    }

    .match-table td {
        min-width: 90px;

    }
    .match-control {
        padding-top: 5px;
    }

    .match-control i {
        font-size: 17px;
    }

    .match-control .ribbon {
        font-size: 14px !important;
        width: 70px;
        right: -13px;
        position: relative;
        background: #fff;
        color: #000;
        text-shadow: none;
        text-align: center;
        padding: 8px 5px 8px 0px;
        top: 5px;
    }
    .match-control .ribbon a{
        color: #000;
    }
    .match-control .ribbon:after {
        right: 100%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }

    .match-control .ribbon:after {
        border-color: rgba(255, 255, 255, 0);
        border-right-color: #fff;
        border-width: 15px;
        top: 50%;
        margin-top: -15px;
    }
    .match-control .ribbon .ribbon-content:after {
        content: "";
        position: absolute;
        display: block;
        border-style: solid;
        border-color: #999 transparent transparent transparent;
        bottom: -10px;
    }
    .match-control .ribbon .ribbon-content:after {
        right: 0;
        border-width: 10px 10px 0 0;
    }

    .date-time{
        font-size: 12px !important;
        font-weight: normal;
        width: 80px;
        text-align: center;
    }
    .date-time .ribbon:after {
        left: 100%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }

    .date-time .ribbon:after {
        border-color: rgba(255, 255, 255, 0);
        border-left-color: #313a54;
        border-width: 15px;
        top: 50%;
        margin-top: -15px;
    }
    .date-time .ribbon .ribbon-content:before {
        content: "";
        position: absolute;
        display: block;
        border-style: solid;
        border-color: transparent #999 transparent transparent;
        bottom: -10px;
    }
    .date-time .ribbon .ribbon-content:before {
        left: -10px;
        border-width: 0 10px 10px 10px;
    }

    .match-detail-container {
        min-width: 1100px;
        width: 100%;
        height:80vh;
        overflow: auto;
        border: none
    }

    .match-detail-stat-container {
        width: 100%;
        height: 99%;
        overflow: auto;
        border: none
    }

    .crib{
        width: 100%;
        height: 50px;
        position: relative;
        float: left;
    }


    .rib {
        /* See "NOTE 3" */
        position:relative;
        z-index:1;
        width:100%;
        padding: 2px 18px 2px 18px;
    }

    .rib h1 {
        position:relative;
        padding:10px 20px;
        margin:0 -30px 10px;
        font-size: 14px;
        line-height:22px;
        font-weight:bold;
        text-align:left;
        color:#fff;
        background:#313a54;
        /* css3 extras */
        text-shadow:0 1px 1px rgba(0,0,0,0.2);
        -webkit-box-shadow:0 1px 1px rgba(0,0,0,0.2);
        -moz-box-shadow:0 1px 1px rgba(0,0,0,0.2);
        box-shadow:0 1px 1px rgba(0,0,0,0.2);
        /* See "NOTE 1" */
        zoom:1;
    }

    .rib h1:before,
    .rib h1:after {
        content:"";
        position:absolute;
        /* See "NOTE 2" */
        z-index:-1;
        top:100%;
        left:0;
        border-width:0 10px 10px 0;
        border-style:solid;
        border-color:transparent #999;
    }

    .rib h1:after {
        left:auto;
        right:0;
        border-width:0 0 10px 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/sportsbook/liveUpcaming.vue